<template>
  <div v-if="countReviews > 3" class="d-flex flex-column align-center">
    <span id="count-reviews" class="text-secondary">
      {{ $t('public-profile.countReviews', { count: props.countReviews }) }}
    </span>
    <div class="d-flex align-center ga-2 pa-5 pt-0">
      <Logo width="35px" class="mx-auto" />
      <!-- TODO when API ready -->
      <v-progress-linear
        rounded
        color="secondary"
        :model-value="props.reviewPercentage"
      ></v-progress-linear>
      <span class="text-secondary">{{ props.reviewPercentage }}%</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Logo from '../Logo.vue'
const props = defineProps({
  reviewPercentage: {
    type: Number,
  },
  countReviews: {
    type: Number,
  },
})
</script>
